import FormErrorAttribute from 'types/FormErrorAttribute';

export interface ErrorData {
  Header: FormErrorAttribute;
  PrefectureCode: FormErrorAttribute;
  SchoolYearCode: FormErrorAttribute;
}

export const CreateEmptyErrorData = () => {
  return {
    Header: {} as FormErrorAttribute,
    PrefectureCode: {} as FormErrorAttribute,
    SchoolYearCode: {} as FormErrorAttribute,
  } as ErrorData;
};
